// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OP80","toggle":"styles_toggle__1Yte7","preview":"styles_preview__v6l1C"};